import type { Team, TeamBase } from "../../types";
import { createBaseService } from "./baseService";

const base = createBaseService<Team, TeamBase>({
  tableName: "teams",
  searchColumns: ["name"],
});

export class TeamService {
  static getAll = base.getAll;
  static get = base.get;
  static create = base.create;
  static createMany = base.createMany;
  static update = base.update;
  static delete = base.delete;
}
